module.exports = __webpack_public_path__ + "img/stage-4-animated.171d1554.png";